import React from 'react';
import { defaultRouter } from 'app/common/router';
import { renderTopLevelComponent } from 'app/scripts/controller/renderTopLevelComponent';
import { LazyPowerUpDirectory } from 'app/src/components/PowerUpDirectory';
import { LazyAppManagement } from 'app/src/components/AppManagement';

export const routes = [
  ['power-ups/admin(/:section)(/)', 'powerUpAdmin'],
  ['power-ups/:idPlugin/edit(/:subsection)(/)', 'editPowerUpPage'],
  ['power-ups(/:section)(/:subsection)(/)', 'publicDirectory'],
];

export const powerUpAdmin = (section?: string, subsection?: string) => {
  renderTopLevelComponent(
    <LazyAppManagement section={section} subsection={subsection} />,
  );
};

export const editPowerUpPage = (idPlugin: string, subsection?: string) => {
  renderTopLevelComponent(
    <LazyAppManagement section={idPlugin} subsection={subsection} />,
  );
};

export const publicDirectory = (section?: string, subsection?: string) => {
  const route = defaultRouter.getRoute();
  const query = route.url.searchParams.get('q') || '';

  renderTopLevelComponent(
    <LazyPowerUpDirectory
      section={section}
      subsection={subsection}
      query={query}
    />,
  );
};
